<template>
  <div class="relative container my-14 lg:my-20">
    <img
      src="/images/contact-v-1.webp"
      alt="contact vector 1"
      class="lg:absolute top-0 lg:-start-32"
    />
    <div class="flex flex-col lg:flex-row bg-white rounded-xl overflow-hidden">
      <div class="contactUs-details px-10 py-14 text-white shrink-0">
        <h3 class="text-xl lg:text-2xl font-bold mb-8">معلومات التواصل</h3>
        <p class="font-medium mb-6">أرقام الهاتف</p>
        <p class="flex items-center gap-x-3 mb-2">
          <svg-icon name="phone" class="fill-current w-4 h-4" />
          {{ contacts?.phone }}
        </p>
        <p class="flex items-center gap-x-3 mb-2">
          <svg-icon name="whatsapp" class="fill-current w-4 h-4" />
          {{ contacts?.whatsapp }}
        </p>

        <p class="font-medium my-6">البريد الإلكتروني</p>
        <p class="flex items-center gap-x-3 mb-2">
          <svg-icon name="envelope" class="fill-current w-4 h-4" />
          {{ contacts?.email }}
        </p>
      </div>
      <div class="w-full px-6 py-14">
        <h3 class="text-xl lg:text-2xl font-bold mb-10">تواصل معنا</h3>

        <form @submit="onSubmit" class="flex flex-col gap-y-6">
          <InputText name="name" label="الإسم" placeholder="الإسم" />
          <InputText
            name="email"
            label="البريد الإلكتروني"
            placeholder="muhammad_s@gmail.com"
          />
          <InputText
            name="phone"
            label="رقم الهاتف (اختيارى)"
            placeholder="+699 12541 3281 3"
          />

          <InputText
            type="textarea"
            name="message"
            label="الرساله"
            placeholder="كيف نقدر نساعدك؟"
          />

          <button
            class="px-20 py-4 text-white bg-sky-400 flex items-center gap-x-2 w-max font-bold rounded-xl transition-all duration-150 border border-sky-400 hover:bg-sky-200 hover:text-sky-400"
            type="submit"
          >
            <Loading v-if="loading" size="xs" />
            إرسل
          </button>
        </form>
      </div>
    </div>

    <img
      src="/images/contact-v-2.webp"
      alt="contact vector 2"
      class="lg:absolute lg:-bottom-10 lg:-end-32 mt-10 lg:mt-0"
    />
  </div>
</template>

<script lang="ts" setup>
import {useForm} from "vee-validate";
import * as yup from "yup";

const schema = yup.object({
  name: yup.string().required("هذا الحقل مطلوب"),
  message: yup.string().required("هذا الحقل مطلوب"),
  email: yup.string().required("هذا الحقل مطلوب").email("هذا البريد غير صحيح"),
  phone: yup.string(),
});

const {defineInputBinds, errors, handleSubmit, resetForm} = useForm({
  validationSchema: schema,
});

const {contacts} = useContacts();
const {onContactUs, loading} = useContactUs();

const onSubmit = handleSubmit(async (values) => {
  if (!values) return;
  await onContactUs(values);
  resetForm();
});
</script>
<style lang="postcss" scoped>
.contactUs {
  &-details {
    background: url("/images/contact-image.webp") no-repeat center center;
    background-size: cover;
    @screen lg {
      width: 430px;
    }
  }
}
</style>
